/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService, AuthBaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';
import { XFoundHttpClient } from '@/core/components/authentication/http/abstractions/xfound.httpclient';

import { GetAllAnredenQuery as AceXFoundPortalCoreCaqAnredeQueriesGetAllAnredenQuery } from '../models/ace/xFound/Portal/Core/CAQ/Anrede/Queries/get-all-anreden-query';
import { GetAllAnredenResponse as AceXFoundPortalCoreCaqAnredeQueriesGetAllAnredenResponse } from '../models/ace/xFound/Portal/Core/CAQ/Anrede/Queries/get-all-anreden-response';

@Injectable({
providedIn: 'root',
})

export class AnredeService extends BaseService {
constructor(
config: ApiConfiguration,
http: HttpClient,
authHttp: XFoundHttpClient
) {
super(config, http, authHttp);
}

  /**
   * Path part for operation apiAnredeGet
   */
  static readonly ApiAnredeGetPath = '/api/Anrede';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiAnredeGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiAnredeGet$Plain$Response(params?: {
    query?: AceXFoundPortalCoreCaqAnredeQueriesGetAllAnredenQuery;
  }): Observable<StrictHttpResponse<AceXFoundPortalCoreCaqAnredeQueriesGetAllAnredenResponse>> {

    const rb = new RequestBuilder(this.rootUrl, AnredeService.ApiAnredeGetPath, 'get');
    if (params) {
      rb.query('query', params.query, {});
    }

    return this.authHttp.request(rb.build({
      responseType: 'json',
      accept: 'text/plain',
      withCredentials: true,
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<AceXFoundPortalCoreCaqAnredeQueriesGetAllAnredenResponse>;
      })
    );
    
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiAnredeGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiAnredeGet$Plain(params?: {
    query?: AceXFoundPortalCoreCaqAnredeQueriesGetAllAnredenQuery;
  }): Observable<AceXFoundPortalCoreCaqAnredeQueriesGetAllAnredenResponse> {

    return this.apiAnredeGet$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<AceXFoundPortalCoreCaqAnredeQueriesGetAllAnredenResponse>) => r.body as AceXFoundPortalCoreCaqAnredeQueriesGetAllAnredenResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiAnredeGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiAnredeGet$Response(params?: {
    query?: AceXFoundPortalCoreCaqAnredeQueriesGetAllAnredenQuery;
  }): Observable<StrictHttpResponse<AceXFoundPortalCoreCaqAnredeQueriesGetAllAnredenResponse>> {

    const rb = new RequestBuilder(this.rootUrl, AnredeService.ApiAnredeGetPath, 'get');
    if (params) {
      rb.query('query', params.query, {});
    }

    return this.authHttp.request(rb.build({
      responseType: 'json',
      accept: 'text/json',
      withCredentials: true,
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<AceXFoundPortalCoreCaqAnredeQueriesGetAllAnredenResponse>;
      })
    );
    
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiAnredeGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiAnredeGet(params?: {
    query?: AceXFoundPortalCoreCaqAnredeQueriesGetAllAnredenQuery;
  }): Observable<AceXFoundPortalCoreCaqAnredeQueriesGetAllAnredenResponse> {

    return this.apiAnredeGet$Response(params).pipe(
      map((r: StrictHttpResponse<AceXFoundPortalCoreCaqAnredeQueriesGetAllAnredenResponse>) => r.body as AceXFoundPortalCoreCaqAnredeQueriesGetAllAnredenResponse)
    );
  }

}